import { n, t } from '../l10n.js'

export default {
	methods: {
		n,
		t,
	},
}
